<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title">
      <div class="title-wrapper">
        {{
          note?.id
            ? ('components.updateSubmissionNoteItem.titleEdit' | translate)
            : ('components.updateSubmissionNoteItem.titleAdd' | translate)
        }}
      </div>
      @if (shouldRenderTooltip) {
        <app-tooltip [text]="'addReadingRoomSubmissionNoteBackoffice'" [marginBottom]="false" [position]="'top-right'"></app-tooltip>
      }
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>

  <div class="lna-modal-body">
    @if (isCrudLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isCrudLoading"></app-spinner>
      </div>
    }

    <form [formGroup]="form" [ngClass]="{ hidden: isCrudLoading }">
      <div class="mb-3">
        <label class="form-label lna" for="text">
          {{ 'components.updateSubmissionNoteItem.text' | translate }}
          <span class="required-field">*</span>
        </label>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna m-0 p-0"
            id="text"
            [ngClass]="{ invalid: shouldRenderError('text') }"
            rows="5"
            maxlength="{{ maxLength }}"
            formControlName="text"
            required></textarea>
          <p class="length" [ngClass]="{ invalid: text?.value?.length > maxLength }">{{ text?.value?.length }}/{{ maxLength }}</p>
        </div>
        @if (getErrorMessage('text'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>

      <div class="value-wrapper file-list">
        <app-file-upload
          [isEditMode]="true"
          [existingFiles]="getFiles()"
          [type]="submissionNoteFileType"
          [associatedEntityId]="note?.id || ''"
          [showDescription]="false"
          [isSubmitting]="isSubmittingFiles"
          (uploading)="onFileUploadCompleted($event)" />
      </div>
    </form>
  </div>

  <div class="lna-modal-footer">
    <button class="primary" (click)="submit()" type="button">
      {{ note?.id ? ('components.updateSubmissionNoteItem.save' | translate) : ('components.updateSubmissionNoteItem.save' | translate) }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.updateSubmissionNoteItem.cancel' | translate }}
    </button>
  </div>
</ng-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title">
      {{ note?.id ? ('components.updateClientNoteItem.titleEdit' | translate) : ('components.updateClientNoteItem.titleAdd' | translate) }}
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>

  <div class="lna-modal-body">
    @if (isCrudLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isCrudLoading"></app-spinner>
      </div>
    }

    <form [formGroup]="form" [ngClass]="{ hidden: isCrudLoading }">
      <div class="mb-3">
        <label class="form-label lna" for="text">
          {{ 'components.updateClientNoteItem.text' | translate }}
          <span class="required-field">*</span>
        </label>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            id="text"
            [ngClass]="{ invalid: shouldRenderError('text') }"
            rows="5"
            maxlength="{{ maxLength }}"
            formControlName="text"
            required></textarea>
          <p class="length" [ngClass]="{ invalid: text?.value?.length > maxLength }">{{ text?.value?.length }}/{{ maxLength }}</p>
        </div>
        @if (shouldRenderError('text') && text?.errors) {}
      </div>

      <div class="value-wrapper file-list">
        <app-file-upload
          [isEditMode]="true"
          [existingFiles]="getFiles()"
          [type]="submissionNoteFileType"
          [associatedEntityId]="note?.id || ''"
          [showDescription]="false"
          [isSubmitting]="isSubmittingFiles"
          (uploading)="handleFileRequests($event)" />
      </div>
    </form>
  </div>

  <div class="lna-modal-footer">
    <button class="primary" (click)="submit()" type="button">
      {{ note?.id ? ('components.updateClientNoteItem.save' | translate) : ('components.updateClientNoteItem.save' | translate) }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.updateClientNoteItem.cancel' | translate }}
    </button>
  </div>
</ng-template>
